<template>
  <div class="syllabus-tree" style="font-family: sans-serif !important; padding-left: 0 !important; border-bottom: 2px solid #d1d7dc;">
    <syllabus-chapters-tree-child-node
      v-for="chapter in chapters"
      :key="chapter.slug"
      :chapter="chapter"
      :first_active_slug="first_active_slug"
      :watching_icons_and_links_enabled="watching_icons_and_links_enabled"
    ></syllabus-chapters-tree-child-node>
  </div>
</template>

<script>
import SyllabusChaptersTreeChildNode from './SyllabusChaptersTreeChildNode';

export default {
  name: 'SyllabusChaptersTree',
  components: {
    'syllabus-chapters-tree-child-node': SyllabusChaptersTreeChildNode
  },

  props: {
    chapters: { type: Array, required: true },
    first_active_slug: { type: String, required: false, default: null },
    watching_icons_and_links_enabled: { type: Number, required: false, default: 0 }
  }
};
</script>
